import { render, staticRenderFns } from "./group_mobile.vue?vue&type=template&id=7196db99&"
import script from "./group_mobile.vue?vue&type=script&lang=js&"
export * from "./group_mobile.vue?vue&type=script&lang=js&"
import style0 from "./group_mobile.vue?vue&type=style&index=0&id=7196db99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports